import { useColorModeValue } from '@chakra-ui/react'

/**
 * Centralized theme-aware colors hook
 * Uses ActionLabs brand colors (aligned with legacy frontend)
 */
export function useThemeColors() {
  return {
    // Page / app background
    bg: useColorModeValue('#FFFCFC', '#0E1116'),
    // Backgrounds
    cardBg: useColorModeValue('#FFFFFF', '#151A21'),
    sectionBg: useColorModeValue('#FFFFFF', '#0E1116'),

    gradientbg: useColorModeValue('linear-gradient(to-l, #E35D5B, #E53935)', 'linear-gradient(to-l, #E35D5B, #E53935)'),

    // Text
    heading: useColorModeValue('#0F172A', '#F1F5F9'),
    text: useColorModeValue('#111113', '#CBD5E1'),
    textSecondary: useColorModeValue('#858D9C', '#94A3B8'),
    textMuted: useColorModeValue('#858D9C', '#64748B'),

    // Links & interactive
    link: useColorModeValue('#1F2937', '#CBD5E1'),
    linkHover: useColorModeValue('#2563EB', '#60A5FA'),

    // Borders / dividers (transparent gray)
    border: useColorModeValue(
      'rgba(15, 23, 42, 0.12)',
      'rgba(148, 163, 184, 0.2)'
    ),
    borderLight: useColorModeValue(
      'rgba(15, 23, 42, 0.06)',
      'rgba(148, 163, 184, 0.12)'
    ),

    // Inputs
    inputBg: useColorModeValue('#FFFFFF', '#1E293B'),
    inputBorder: useColorModeValue(
      'rgba(15, 23, 42, 0.2)',
      'rgba(148, 163, 184, 0.3)'
    ),

    // Primary brand (ActionLabs red)
    primary: useColorModeValue('#973134', '#EF5350'),
    primaryHover: useColorModeValue('#D32F2F', '#E57373'),

    // Secondary brand
    secondary: useColorModeValue('#1E293B', '#CBD5E1'),

    // Status
    error: useColorModeValue('#EF4444', '#F87171'),
    progressBg: useColorModeValue('#E5E7EB', '#334155'),

    // Highlight / email / accents
    email: useColorModeValue('#2563EB', '#60A5FA'),

    // Upload / hover states
    uploadHover: useColorModeValue('#EFF6FF', '#1E3A8A'),
    uploadIcon: useColorModeValue('#6B7280', '#94A3B8'),
    // Brand Blue (Primary Action)
    brandBlue: useColorModeValue('#205BF3', '#3B82F6'),
    brandBlueHover: useColorModeValue('#1A4ED8', '#60A5FA'),
    brandBlueActive: useColorModeValue('#163FAE', '#2563EB'),

    //sidebar
    sidebarBg: useColorModeValue('#FFFFFF', '#0E1116'),
    sidebarText: useColorModeValue('#4B5563', '#9CA3AF'),
    sidebarActiveBg: useColorModeValue('#FFF5F5', '#FFF5F5'),
    sidebarHoverBg: useColorModeValue('#ffffff', '#1E293B'),


    //Form
    inputborderHover: useColorModeValue('#D1D5DB', '#475569'),
    buttonBg: useColorModeValue('#973134', '#EF5350'),
    buttonHoverBg: useColorModeValue('#D32F2F', '#E57373'),
    buttonActiveBg: useColorModeValue('#B71C1C', '#EF4444'),
  }
}
